import {
    iplpRecipeFields,
} from '../folder-e-prescription-magistraliter-recipes/folder-e-prescription-magistraliter-recipes.query';

export const iplpRecipesFrag = iplpRecipeFields;

export const iplpRecipeDetailFrag = `
    ${iplpRecipeFields}
    insurancePayment
    prescription
    dosing
    sections {
        key
        html
    }
`;
